import I18n from '@/i18n/config';
import { downloadCSV } from '@klp/helpers';

import type { TableColumnDef } from '../components/TableColumnDef';

export interface CsvExportOptions<DataType> {
    columns: Array<TableColumnDef<DataType, unknown>>;
    data: Array<DataType>;
    filename: string;
}

function handleArrayValue(value: unknown): string {
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    return String(value);
}

/**
 * Export table data to CSV file
 * Replaces the saga-based table download with a simple utility function
 */
export function exportTableToCSV<DataType>({
    columns,
    data,
    filename,
}: CsvExportOptions<DataType>): void {
    const columnTitles = columns.map((col: TableColumnDef<DataType, unknown>) =>
        I18n.t(col.translation),
    );

    const columnNames = columns.map(
        (col: TableColumnDef<DataType, unknown>) => col.key,
    );

    const output = [
        columnTitles,
        ...data.map((row) =>
            columnNames.map((columnName) =>
                handleArrayValue(row[columnName as keyof DataType]),
            ),
        ),
    ];

    downloadCSV(output, filename, false);
}
